/**
 * Texts for Press Releases page
 */
export const pressReleasesPageText = {
    title: 'Pressemitteilungen - CamAPS FX',
    titleMeta: 'Pressemitteilungen - CamAPS FX',
    descriptionMeta: 'Aktuelle Pressemitteilungen und Neuigkeiten von CamAPS FX.',
    keywords: 'camaps pressemitteilungen, camaps nachrichten, diabetes technologie nachrichten',
    localeMeta: 'de_de',

    bannerTitle: 'Pressemitteilungen',
    bannerSubtitle: 'Bleiben Sie auf dem Laufenden mit unseren neuesten Ankündigungen',

    contactText: 'Für Presseanfragen kontaktieren Sie uns bitte über <a href="mailto:media@camdiab.com">media@camdiab.com</a>',
    pressReleasesDisclaimer: 'Alle Pressemitteilungen werden auf Englisch veröffentlicht.',

    download: 'Herunterladen',
    showMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
};

